/**
 * Returns the THD customer object from the window, or an empty object if not available.
 * Only call this function inside useEffect or event handlers to avoid SSR hydration mismatch.
 */
export const getThdCustomer = () => {
  if (typeof window === 'undefined') return {};
  return window.THDCustomer?.default || {};
};

export const isGuest = () => {
  if (typeof window === 'undefined') return true;
  if (!window.THDCustomer?.default) return true;
  return !window.THDCustomer.default.isLoggedIn;
};

export const getMcvisId = (mcvisID) => {
  const FALLBACK_MCVISID_PREFIX = 'fallback';
  const STORAGE_KEY = 'thd_fallback_mcvisid';

  // Return provided mcvisID if valid
  if (mcvisID?.trim()) {
    return mcvisID;
  }

  // Generate and persist new fallback mcvisID
  const uuid = window?.crypto?.randomUUID?.() || Date.now();
  const fallbackMcvisId = `${FALLBACK_MCVISID_PREFIX}-${uuid}`;
  if (typeof window !== 'undefined' && window.localStorage) {
    // Return stored fallback mcvisID if it exists
    const storedMcvisId = window.localStorage.getItem(STORAGE_KEY);
    if (storedMcvisId) {
      return storedMcvisId;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, fallbackMcvisId);
    } catch (error) {
      // localStorage not available or quota exceeded
    }
  }
  return fallbackMcvisId;
};